import React from 'react';
import QRCode from 'qrcode.react';
import moment from 'moment';

import { Table, } from 'react-bootstrap';
import { IconButton, } from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';


function UsersTable({ users, onDelete, }) {
  return (
    <Table
      hover
      responsive
    >
      <thead>
        <tr>
          <th>Nome</th>
          <th>Grupo</th>
          <th>Data criação</th>
          <th></th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {
          users
            .map((user) => {
              return (
                <tr key={user._id} >
                  <td>
                    {user.name}
                  </td>
                  <td>
                    {user.group}
                  </td>
                  <td>{moment(user.createdAt).format('DD-MM-YY HH:mm')}</td>
                  <td>
                    {
                      user.qrCode ?
                      <QRCode value={user.qrCode} /> :
                      null
                    }
                  </td>

                  <td
                    style={{
                      textAlign: 'center',
                      verticalAlign: 'middle',
                    }}
                  >
                    <IconButton
                      aria-label="delete user"
                      onClick={() => onDelete(user._id)}
                      size="small"
                      color="secondary"
                      disabled={undefined == onDelete}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </td>
                </tr>
              );
            })
        }
      </tbody>
    </Table>
  );
}

export default UsersTable;
